<template>
<div style="width: 1000px;margin: auto">
  <p style="text-indent: 59px; text-align: center;margin-bottom: 30px">
    <strong><span style="font-size:29px">中国中小企业诚信服务联盟背景</span></strong>
</p>

<p style="text-align:left;line-height: 40px">
    <span style="font-size:24px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2016</span><span style="font-size:24px">年7月5日工信部印发了《促进中小企业发展规划（2016－2020年）》，明确提出推进中小企业信用体系建设：</span>
    <span style="font-size: 24px">依托全国信用信息共享平台，推动建立中小企业信用信息共享机制。</span>
</p>
<p style="text-align:left;line-height: 40px">
    <span style="font-size: 24px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;支持利用大数据以及各类信息资源，建立包括企业纳税信息、进销存信息、诚信经营信息等中小企业信用信息平台。</span>
</p>
<p style="text-align:left;line-height: 40px">
    <span style="font-size: 24px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;鼓励各类平台畅通与银行业金融机构间的信用信息渠道，便于金融机构对中小企业进行评级及授信。</span>
</p>
<p style="text-align:left;line-height: 40px">
    <span style="font-size: 24px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;鼓励各类信用服务机构提供有效服务，为中小企业融资提供便利。</span>
</p>
<p style="text-align:left;line-height: 40px">
    <span style="font-size:24px">&nbsp;</span>
</p>
<p>
    <br/>
</p></div>
</template>

<script>
export default {
  name: 'lmbj'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/computer/lmbj.vue